import React, { useEffect, useState } from "react";
import axios from "axios";
import { browserHistory } from "react-router";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import ClearIcon from "@material-ui/icons/Clear";
import { Button, notification, Divider, Space } from "antd";
import "antd/dist/antd.css";
import TrendingFlatIcon from "@material-ui/icons/TrendingFlat";
import InfiniteScroll from "react-infinite-scroll-component";
import styles from "./recent-transactions.scss";
import sell from "../../public/Sell-Withdraw - Icon.svg";
import buy from "../../public/Buy-Reinvest - Icon.svg";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import SearchIcon from "@material-ui/icons/Search";
import metacoinConfig from "../../metacoin-config";
import Contract_obj from "../../getTronweb";
// import { Pagination } from "antd";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { makeStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import { Empty } from "antd";

import Snackbar from "@material-ui/core/Snackbar";
const useStyles = makeStyles(theme => ({
  root: {
    "& > *": {
      marginTop: theme.spacing(2),
    },
  },
  ul: {
    ".MuiPagination-ul": {
      backgroundColor: "#691AAA",
    },
  },
}));
const Transactions = ({ state, type, updated, setUpdated, history, props }) => {
  const [txns, setTxns] = useState([]);
  const [txns_to_show, set_txns_to_show] = useState([]);
  const [page, setPage] = useState(1);
  const [paginator, setPaginator] = useState(0);
  const [count, setCount] = useState(0);
  const [current_timestamp, setCurrentTimestamp] = useState(0);
  const [loading, setLoading] = useState(true);
  const [ids, setIds] = useState([]);
  const [node, setNode] = useState();
  const [path, setPath] = useState(
    window.location.pathname == "transactions" ||
      window.location.pathname == "/transactions"
      ? 1
      : 0
  );
  const [notif, setNotif] = useState(false);
  const [notifMsg, setNotifMsg] = useState("");
  const [positions, setPositions] = React.useState({
    vertical: "bottom",
    horizontal: "right",
  });

  const { vertical, horizontal } = positions;
  const classes = useStyles();
  const getUpdatedData = () => {
    var config = {
      method: "get",
      url: `${metacoinConfig.fullHost}/v1/contracts/${
        metacoinConfig.contractAddressBase
      }/events?limit=200&order_by=block_timestamp,desc&min_block_timestamp=${
        txns[0] && txns[0].block_timestamp
      }`,
      headers: {},
    };
    var temp = [];

    axios(config)
      .then(function (response) {
        var data = response.data;
        console.log(data, "Transactions updated");

        temp = temp.concat(data.data);
        temp = temp.slice(0, temp.length - 1);
        temp = temp.filter(txn =>
          [
            "onWithdraw",
            "onReinvestment",
            "Transfer",
            "onTokenPurchase",
            "onTokenSell",
          ].includes(txn.event_name)
        );

        temp = temp.filter(
          txn =>
            txn.result &&
            !ids.includes(txn.transaction_id) && Contract_obj.tronWebProvider.defaultAddress.hex &&
            txn.result[0].slice(2) ==
              Contract_obj.tronWebProvider.defaultAddress.hex.slice(2)
        );
        var temp_len = temp.length - 1;
        var filtered = temp;
        var i = 0;

        while (i < temp_len) {
          if (temp[i].transaction_id == temp[i + 1].transaction_id) {
            filtered = filtered.filter(val => val != temp[i + 1]);
            i += 2;
          } else {
            i += 1;
          }
        }
        temp = filtered;
        console.log(temp, "txns", txns);
        var all_txns = temp.concat(txns);
        setTxns(all_txns);
        var updated_txns_to_show = temp.concat(txns_to_show);
        set_txns_to_show(updated_txns_to_show);
        setLoading(false);
      })
      .catch(err => {
        console.log(err, "err");
        setLoading(false);
      });
  };
  const getTransactions = () => {
    var node__ =
      window.tronWeb &&
      window.tronWeb.fullNode.host == "https://api.shasta.trongrid.io"
        ? "shasta"
        : "mainnet";
    setNode(node__);
    var config = {
      method: "get",
      url: `${metacoinConfig[node__].fullHost}/v1/contracts/${metacoinConfig[node__].contractAddressBase}/events?limit=200&order_by=block_timestamp,desc`,
      headers: {},
    };
    var temp = [];
    var temp2 = []
    function getData() {
      axios(config)
        .then(function (response) {
          var data = response.data;
          // console.log(data, "Transactionss");

          temp = temp.concat(data.data);
          temp2 = temp2.concat(data.data)
          temp = temp.filter(txn =>
            [
              "onWithdraw",
              "onReinvestment",
              "Transfer",
              "onTokenPurchase",
              "onTokenSell",
            ].includes(txn.event_name)
          );
          // console.log(temp, "temp f1");

          temp = temp.filter(
            txn =>
              txn.result && Contract_obj.tronWebProvider.defaultAddress.hex &&
              (txn.result[0].slice(2) == 
                Contract_obj.tronWebProvider.defaultAddress.hex.slice(2) ||
                (txn.event_name == "Transfer" &&
                  txn.result.to.slice(2) ==
                    Contract_obj.tronWebProvider.defaultAddress.hex.slice(2)))
          );
          // console.log(temp, "temp f2");

          var temp_len = temp.length - 1;
          var filtered = temp;
          var i = 0;

          while (i < temp_len) {
            if (temp[i].transaction_id == temp[i + 1].transaction_id && temp[i].event_name == "Transfer" && temp[i+1].event_name == "onTokenPurchase") {
              filtered = filtered.filter(val => val != temp[i]);
              i += 2;
            }
            else if (temp[i].transaction_id == temp[i + 1].transaction_id) {
              filtered = filtered.filter(val => val != temp[i + 1]);
              i += 2;
            } else {
              i += 1;
            }
          }
          temp = filtered;
          // console.log(temp, "temp f3");

          var temp_ids = ids;

          temp.forEach(element => {
            temp_ids.push(element.transaction_id);
          });
          setIds(temp_ids);
          // console.log(temp, "Transactionsss", temp_ids);

          if (data.meta.links) {
            config.url = data.meta.links.next;
            getData();
          } else {
            setTxns(temp);
            let total_pages = temp.length % 10;
            if (total_pages === 0) {
              setCount(temp.length / 10);
            } else {
              setCount(Math.floor(temp.length / 10) + 1);
            }
            setLoading(false);
          }
        })
        .catch(err => {
          console.log(err, "err");
          var timestamp_ = temp2[temp2.length - 1].block_timestamp
          console.log(timestamp_, "timestamp_")
          config.url = `${metacoinConfig[node__].fullHost}/v1/contracts/${metacoinConfig[node__].contractAddressBase}/events?limit=200&order_by=block_timestamp,desc&max_block_timestamp=${timestamp_}`;
          getData();

          // setLoading(false);
        });
    }
    getData();
  };
  useEffect(() => {
    getPaginator();
    localStorage.setItem(
      "latest_timestamp",
      txns[0] && txns[0].block_timestamp
    );
  }, [txns]);
  useEffect(() => {
    setLoading(true);
    window.tronWeb && window.tronWeb.defaultAddress.hex
      ? getTransactions()
      : setLoading(false);
    console.log("UPDATED");
  }, [updated]);

  const getPaginator = () => {
    var txn = txns_to_show;
    console.log("path", path);
    var new_txns =
      path == 1
        ? txns.slice(0, paginator * 10 + 10)
        : txns.slice(0, paginator * 5 + 5);

    set_txns_to_show(new_txns);
    setPaginator(paginator + 1);
  };

  const getEvents = async () => {
    let contract = Contract_obj.contract_instace;

    var placement = "bottomRight";

    console.log(contract, "contractnn");
    (await contract) &&
      contract.onTokenPurchase().watch((err, event) => {
        if (err) return console.error('Error with "Message" event:', err);

        if (
          event &&
          window.tronWeb.address.fromHex(event.result.customerAddress) !=
            Contract_obj.accounts[0]
        ) {
          setNotifMsg(
            (parseInt(event.result.incomingTron) / 1e6).toFixed(2).toString()
          );
          setNotif(true);
        } else {
          // setUpdated(updated + 1);
        }
        setUpdated(updated + 1);

        console.group("New event received");
        console.log("- event:", event.contract);
        console.groupEnd();
      });
    (await contract) &&
      contract.onTokenSell().watch((err, event) => {
        if (err) return console.error('Error with "Message" event:', err);
        if (event) {
          setUpdated(updated + 1);
        }

        console.group("New event received");
        console.log("- event: sell");
        console.groupEnd();
      });
    (await contract) &&
      contract.onReinvestment().watch((err, event) => {
        if (err) return console.error('Error with "Message" event:', err);
        if (event) {
          setUpdated(updated + 1);
        }

        console.group("New event received");
        console.log("- event: reinvest");
        console.groupEnd();
      });
    (await contract) &&
      contract.onAutoReinvestmentStop().watch((err, event) => {
        if (err) return console.error('Error with "Message" event:', err);
        if (event) {
          setUpdated(updated + 1);
        }

        console.group("New event received");
        console.log("- event: onAutoReinvestmentStop");
        console.groupEnd();
      });
    (await contract) &&
      contract.Transfer().watch((err, event) => {
        if (err) return console.error('Error with "Message" event:', err);
        if (event) {
          setUpdated(updated + 1);
        }

        console.group("New event received");
        console.log("- event: Transfer");
        console.groupEnd();
      });
    (await contract) &&
      contract.onWithdraw().watch((err, event) => {
        if (err) return console.error('Error with "Message" event:', err);
        if (event) {
          setUpdated(updated + 1);
        }

        console.group("New event received");
        console.log("- event: onWithdraw");
        console.groupEnd();
      });
  };
  useEffect(() => {
    setLoading(true);

    const loadWatcher = setInterval(async () => {
      console.log("metaconfig", metacoinConfig);

      if (window.tronWeb && window.tronWeb.ready) {
        clearInterval(loadWatcher);
        window.tronWeb && Contract_obj.contract_instace && getEvents();
        var node_ =
          window.tronWeb.fullNode.host == "https://api.shasta.trongrid.io"
            ? "shasta"
            : "mainnet";
        setNode(node_);
        setPaginator(0);
        console.log("metaconfig", metacoinConfig);
        window.tronWeb &&
        Contract_obj.contract_instace &&
        window.tronWeb.defaultAddress.hex
          ? getTransactions()
          : setLoading(false);
      } else {
          setLoading(false);
     
      }
    }, 2000);
  }, []);
  return (
    <div
      className={`transactions`}
      style={{ marginTop: state === 4 && "55px" }}
    >
      <div className={`topdv`} style={{ marginTop: state === 4 && "50px" }}>
        <span className={`title`}>
          {state === 4 ? "Transactions" : " Recent Transactions"}
        </span>

        <div className="rd">
          {state === 4 ? (
            <a
              href={
                node &&
                `${metacoinConfig[node].url}/#/contract/${metacoinConfig[node].contractAddressBase}/transactions`
              }
              target="_blank"
            >
              All CETO Transactions
            </a>
          ) : (
            <span
              onClick={() => history.replace({ pathname: "/transactions" })}
            >
              See all transactions
            </span>
          )}
          <ArrowForwardIosIcon
            style={{
              fontSize: "12px",
              marginTop: "3px",
              marginLeft: "5px",
            }}
          />
        </div>
      </div>

      <div className={`transactionContainer ${type ? "withborder" : ""}`}>
        <div className="transactionContainer__header">
          <span>Date</span>
          <span className="only_l">Type</span>
          <span className="only_l">Transaction No.</span>
          <span>TRX</span>
          <span>CETO</span>
        </div>
        {/* {txns.length} */}
        {!loading ? (
          txns.length > 0 ? (
            state === 4 ? (
              <>
                <div
                  className="transactionContainer__transactionRows"
                  style={{ justifyContent: "start", minHeight: "50vh" }}
                >
                  {txns &&
                    txns.slice((page - 1) * 10, page * 10).map(txnn => {
                      return (
                        <div
                          key={txnn.txID}
                          className="transactionContainer__transactionRow"
                        >
                          {/* <span> */}
                          <span
                            style={{
                              // width: "200px",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {/* <img
                                src={
                                  txnn &&
                                  txnn.event_name &&
                                  [
                                    "onTokenPurchase",
                                    "onReinvestment",
                                  ].includes(txnn.event_name)
                                    ? buy
                                    : sell
                                }
                                width="28"
                                height="28"
                              /> */}

                            <span>
                              {new Date(txnn.block_timestamp).toDateString()}
                            </span>
                          </span>
                          {/* </span> */}
                          <span className="only_l">
                            {txnn &&
                              (txnn.event_name == "onTokenPurchase"
                                ? "Buy"
                                : txnn.event_name == "onTokenSell"
                                ? "Sell"
                                : txnn.event_name == "onWithdraw"
                                ? "Withdraw"
                                : txnn.event_name == "onReinvestment"
                                ? "Reinvest"
                                : Contract_obj.tronWebProvider.defaultAddress.hex && txnn.result[0].slice(2) ==
                                Contract_obj.tronWebProvider.defaultAddress.hex.slice(
                                    2
                                  )
                                ? "Transfer Out"
                                : "Transfer In")}
                          </span>
                          <a
                            className="only_l"
                            target="_blank"
                            href={
                              node &&
                              `${metacoinConfig[node].url}/#/transaction/${txnn.transaction_id}`
                            }
                          >
                            {txnn.transaction_id &&
                              txnn.transaction_id.slice(0, 20)}
                            ...
                          </a>
                          <span>
                            {txnn &&
                            txnn.result &&
                            (txnn.result.incomingTron ||
                              txnn.result.tronEarned ||
                              txnn.result.tronReinvested ||
                              txnn.result.tronWithdrawn)
                              ? (
                                  (txnn.result.incomingTron ||
                                    txnn.result.tronEarned ||
                                    txnn.result.tronReinvested ||
                                    txnn.result.tronWithdrawn ||
                                    0) / 1e6
                                ).toFixed(2)
                              : "-"}{" "}
                            {(txnn.result.incomingTron ||
                              txnn.result.tronEarned ||
                              txnn.result.tronReinvested ||
                              txnn.result.tronWithdrawn) &&
                              "TRX"}
                          </span>
                          <span>
                            {txnn &&
                            txnn.result &&
                            (txnn.result.tokensMinted ||
                              txnn.result.tokensBurned ||
                              txnn.result.tokens)
                              ? (
                                  (txnn.result.tokensMinted ||
                                    txnn.result.tokensBurned ||
                                    txnn.result.tokens) / 1e6
                                ).toFixed(2)
                              : "-"}{" "}
                            {(txnn.result.tokensMinted ||
                              txnn.result.tokensBurned ||
                              txnn.result.tokens) &&
                              "CETO"}
                          </span>
                        
                          </div>
                      );
                    })}
                </div>
                <div className="pagi">
                  <Pagination
                    style={{ color: "#691AAA" }}
                    count={count}
                    pagep={page}
                    onChange={(e, page) => {
                      setPage(page);
                    }}
                    color="primary"
                  />
                </div>
              </>
            ) : (
              <div
                className="transactionContainer__transactionRows"
                style={{ justifyContent: "start" }}
              >
                <InfiniteScroll
                  dataLength={path == 1 ? paginator * 10 : paginator * 5}
                  next={getPaginator}
                  hasMore={true}
                  height={path == 1 ? 600 : 330}
                  // loader={<h4>Loading...</h4>}
                >
                  {txns_to_show &&
                    txns_to_show.map(txnn => {
                      return (
                        <div
                          key={txnn.txID}
                          className="transactionContainer__transactionRow"
                        >
                          {/* <span> */}
                          <span
                            style={{
                              // width: "200px",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {/* <img
                                src={
                                  txnn &&
                                  txnn.event_name &&
                                  [
                                    "onTokenPurchase",
                                    "onReinvestment",
                                  ].includes(txnn.event_name)
                                    ? buy
                                    : sell
                                }
                                width="28"
                                height="28"
                              /> */}

                            <span>
                              {new Date(txnn.block_timestamp).toDateString()}
                            </span>
                          </span>
                          {/* </span> */}
                          <span className="only_l">
                            {txnn &&
                              (txnn.event_name == "onTokenPurchase"
                                ? "Buy"
                                : txnn.event_name == "onTokenSell"
                                ? "Sell"
                                : txnn.event_name == "onWithdraw"
                                ? "Withdraw"
                                : txnn.event_name == "onReinvestment"
                                ? "Reinvest"
                                : Contract_obj.tronWebProvider.defaultAddress.hex && txnn.result[0].slice(2) ==
                                  Contract_obj.tronWebProvider.defaultAddress.hex.slice(
                                    2
                                  )
                                ? "Transfer Out"
                                : "Transfer In")}
                          </span>
                          <a
                            className="only_l"
                            target="_blank"
                            href={
                              node &&
                              `${metacoinConfig[node].url}/#/transaction/${txnn.transaction_id}`
                            }
                          >
                            {txnn.transaction_id &&
                              txnn.transaction_id.slice(0, 20)}
                            ...
                          </a>
                          <span>
                            {txnn &&
                            txnn.result &&
                            (txnn.result.incomingTron ||
                              txnn.result.tronEarned ||
                              txnn.result.tronReinvested ||
                              txnn.result.tronWithdrawn)
                              ? (
                                  (txnn.result.incomingTron ||
                                    txnn.result.tronEarned ||
                                    txnn.result.tronReinvested ||
                                    txnn.result.tronWithdrawn ||
                                    0) / 1e6
                                ).toFixed(2)
                              : "-"}{" "}
                            {(txnn.result.incomingTron ||
                              txnn.result.tronEarned ||
                              txnn.result.tronReinvested ||
                              txnn.result.tronWithdrawn) &&
                              "TRX"}
                          </span>
                          <span>
                            {txnn &&
                            txnn.result &&
                            (txnn.result.tokensMinted ||
                              txnn.result.tokensBurned ||
                              txnn.result.tokens)
                              ? (
                                  (txnn.result.tokensMinted ||
                                    txnn.result.tokensBurned ||
                                    txnn.result.tokens) / 1e6
                                ).toFixed(2)
                              : "-"}{" "}
                            {(txnn.result.tokensMinted ||
                              txnn.result.tokensBurned ||
                              txnn.result.tokens) &&
                              "CETO"}
                          </span>
                        </div>
                      );
                    })}
                </InfiniteScroll>
              </div>
            )
          ) : (
            <div style={{ justifyContent: "center", margin: " 22%" }}>
              <Empty
                image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                imageStyle={{
                  height: 60,
                }}
                description={
                  <span
                    style={{
                      display: "block",
                      color: "#7689b0",
                      textTransform: "capitalize",
                      marginBottom: " 1.2em",
                      fontSize: "18px",
                    }}
                  >
                    No Transactions
                  </span>
                }
              ></Empty>
            </div>
          )
        ) : (
          <div style={{ justifyContent: "center", margin: " 22%" }}>
            <CircularProgress width={28} height={28} />
          </div>
        )}
      </div>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={notif}
        onClose={() => setNotif(false)}
        autoHideDuration={6000}
        // message={notifMsg}
        key={vertical + horizontal}
        className="notifs"
      >
        <div>
          <span>{notifMsg} </span> TRX rides into the Jungle!
          <ClearIcon
            onClick={() => setNotif(false)}
            style={{
              color: "#009EE4",
              width: "15px",
              height: "15px",
              position: "absolute",
              top: "5",
              right: "5",
            }}
          ></ClearIcon>
        </div>
      </Snackbar>
    </div>
  );
};

export default Transactions;
